/* -----------------------------------------------------------------------------
 * Security SM Mutations
 *
 * @description - Mutations of Security SM. Check ./README.md for more info.
 * -----------------------------------------------------------------------------
 */

export default {

  /**
   * Set message callback
   * @description Sets send message callback to state
   * @param {Object} state - Security SM state
   * @param {Function} callback - Given callback
   */
  SET_MESSAGE_CALLBACK (state, callback) {
    state.callback = callback
  },

  /**
   * Unset message callback
   * @description Unsets send message callback from state
   * @param {Object} state - Security SM state
   */
  UNSET_MESSAGE_CALLBACK (state) {
    state.callback = null
  },

  /**
   * Set parent location
   * @description Sets parent location params to state
   * @param {Object} state - Security SM state
   * @param {Object} location - Given location obj
   */
  SET_PARENT_LOCATION (state, location) {
    for (const key in state.location) {
      key in location
        ? state.location[key] = location[key] || ''
        : state.location[key] = ''
    }
  },

  /**
   * Set token
   */
  SET_TOKEN (state, token) {
    state.token = token
  },

  /**
   * Add event
   */
  ADD_EVENT (state, event) {
    state.events.push(event)
  }

}
